$ = require 'jquery'
CardView = require 'app/scripts/views/card/card-view'
{ maybeDisplayLimitsErrorOnCardOpen } = require 'app/scripts/views/card/card-limits-error'
Confirm = require 'app/scripts/views/lib/confirm'
Controller = require 'app/scripts/controller'
Dialog = require 'app/scripts/views/lib/dialog'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
template = require 'app/scripts/views/templates/archived_card_options'
{ track } = require '@trello/analytics'

module.exports = class ArchivedCardView extends View
  tagName: 'div'

  className: 'archived-list-card'

  events:
    'click .list-card': 'openCard'
    'click .js-delete': 'deleteModel'
    'click .js-reopen': 'reopen'

  vigor: @VIGOR.NONE

  renderOnce: ->
    cardView = @subview(CardView, @model, { dontFilter: true, quickEditHidden: true })
    cardView.render()
    @$el.append cardView.el
    @$el.append template({
      editable: @model.editable(),
      canDelete: @options.canDelete
      canReopen: @model.getList()?
      reOpenText: @options.reOpenText
    })
    @

  openCard: (e) ->
    Util.stop(e)
    Controller.showCardDetail(@model)
    Dialog.calcPos()
    return

  deleteModel: (e) ->
    Util.stop(e)
    Confirm.toggle 'delete card',
      elem: $(e.target).closest('.js-delete')?[0]
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.destroy()
        track("Card", "Delete", "Via Archive")
    return

  reopen: (e) ->
    Util.preventDefault(e)
    options = {
      $elem: $(e.target),
      hasAttachments: @model.attachmentList.length > 0,
      destinationBoard: @model.getBoard(),
      destinationList: @model.getList(),
    }
    if maybeDisplayLimitsErrorOnCardOpen(options)
      return

    @model.update { closed: false }, =>
      track('Card', "Reopen", "Via Archive")
    false
